// extracted by mini-css-extract-plugin
export var container = "_dl-0";
export var infoIcon = "_dl-2";
export var internalLabel = "_dl-3";
export var titleRowCol = "_dl-1";